import styles from './Home.module.css';
import React, { useEffect } from 'react'
import Video from './Sections/Video/Video';
import Highlight from './Sections/Highlight/Highlight';
import PME from './Sections/PME/PME';
import Exhibition from './Sections/Exhibition/Exhibition';
import Newsletter from './Sections/Newsletter/Newsletter';
import WhiteSpace2 from '../WhiteSpace/WhiteSpace2';

export type HomeProps = {
    setNavBackground: React.Dispatch<React.SetStateAction<boolean>>;
    setFilterProduct: React.Dispatch<React.SetStateAction<number | null>>;
}

const Home = (props: HomeProps) => {

    useEffect(() => {
        props.setNavBackground(false);
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.section2}>
                <Video />
            </div>
            <div className={`${styles.section} ${styles.homeBackground}`} style={{ backgroundImage: `url('/assets/images/Homepage-degrade---Copy.jpg')` }}>
                <Highlight setFilterProduct={props.setFilterProduct} />
                <PME />
                <Exhibition />
                <Newsletter />
                <WhiteSpace2 height='20vh' />
            </div>
        </div>
    )
}
export default Home